import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "terminal" }, [
  /*#__PURE__*/_createElementVNode("path", {
    id: ".fill",
    d: "M10.0619 12.3535L3.9887 18.4268C3.6958 18.7197 3.22092 18.7197 2.92805 18.4268L2.21967 17.7184C1.92727 17.426 1.9267 16.9521 2.21842 16.659L7.03161 11.8232L2.21845 6.98743C1.92673 6.69433 1.9273 6.22043 2.2197 5.92802L2.92805 5.21968C3.22095 4.92677 3.69583 4.92677 3.9887 5.21968L10.0619 11.2929C10.3548 11.5858 10.3548 12.0606 10.0619 12.3535ZM22 18.0732V17.0732C22 16.659 21.6642 16.3232 21.25 16.3232H11.75C11.3358 16.3232 11 16.659 11 17.0732V18.0732C11 18.4874 11.3358 18.8232 11.75 18.8232H21.25C21.6642 18.8232 22 18.4874 22 18.0732Z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }